import type { LoaderFunctionArgs } from "react-router";
import { Outlet, redirect } from "react-router";
import { sessionStorage } from "~/services/session.server";
import type { GoogleLoginResponse } from "~/types/auth";

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const session = await sessionStorage.getSession(request.headers.get("cookie"));
  const authData = session.get("user") as GoogleLoginResponse | undefined;

  if (authData) {
    throw redirect("/");
  }

  return null;
};

export default function AuthLayout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
